export const chat = {
  Chat: "Chat",
  NewChat: "New Chat",
  NewChatDesc: "Start a new chat.",
  NewChatSuccess: "New chat created.",
  EditChat: "Edit Chat",
  EditChatDesc: "Edit the chat settings.",
  EditChatSuccess: "Chat settings updated.",
  DeleteChat: "Delete Chat",
  DeleteChatDesc: "Delete the chat.",
  DeleteChatSuccess: "Chat deleted successfully.",
  IsConnecting: "Connecting...",
  ConnectionLost: "Connection lost, click this to connect to server.",
  SelectChatToStartMessaging: "Select a chat to start messaging.",
  SelectAdmin: "Select an admin",
  SelectChatToShareData: "Select a chat to share data.",
} as const;
